import type {
  AIChatClarifyMessage,
  AIChatMessageUI,
  AIChatTextMessage,
  ChatMessage,
} from '../types'

const isChatMessage = (
  m: AIChatMessageUI
): m is AIChatTextMessage | AIChatClarifyMessage => {
  return m.type !== 'actions' && m.type !== 'paywall'
}

export const prepareMessagesForRequest = (
  contextMessages: AIChatMessageUI[]
): ChatMessage[] => {
  return contextMessages.filter(isChatMessage).map((m) => {
    const role = m.type === 'clarify' ? 'assistant' : m.type

    return {
      role,
      content: m.text,
    }
  })
}
